exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-data-page__track-detail-tooltip{max-width:min(420px,85vw)}.customer-data-page__track-detail-tooltip .customer-data-page__track-detail-tooltip__body{white-space:pre-wrap;word-break:break-word;text-align:left;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d5cebbd","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/views/CustomerData.vue
// module id = A4di
// module chunks = 0